module.exports = __webpack_public_path__ + "static/media/forest-logo.cede28e3.png";